import * as types from './_actionTypes';

export const fetchSystemAnalyticsRequest = () => ({
  type: types.FETCH_SYSTEM_ANALYTICS_REQUEST
});

export const fetchSystemAnalyticsSuccess = (analytics) => ({
  type: types.FETCH_SYSTEM_ANALYTICS_SUCCESS,
  payload: analytics
});

export const fetchSystemAnalyticsFailure = (error) => ({
  type: types.FETCH_SYSTEM_ANALYTICS_FAILURE,
  payload: error
});

export const exportAnalyticsRequest = (format) => ({
  type: types.EXPORT_ANALYTICS_REQUEST,
  payload: format
});

export const exportAnalyticsSuccess = (data) => ({
  type: types.EXPORT_ANALYTICS_SUCCESS,
  payload: data
});

export const exportAnalyticsFailure = (error) => ({
  type: types.EXPORT_ANALYTICS_FAILURE,
  payload: error
});

export const refreshAnalyticsRequest = () => ({
  type: types.REFRESH_ANALYTICS_REQUEST
});
